import { Alerte, Button, Carte } from "@/shared/ui";

import { CANDIDATE_THEME } from "./candidate/PhoneFrame";
import { usePostuler } from "./usePostuler";

/**
 * Landing publique du recrutement (route `/candidature`).
 *
 * Parti pris : ultra-simple — une seule colonne centrée, un titre, deux phrases,
 * un seul bouton.
 *
 * 🩸 RÉÉCRITE LE 18-08-2026. Elle vendait « L'IA propose. Toi, tu décides » et
 * « tu valides ou tu corriges ses réponses » — le métier de DÉCIDEUR, qui
 * n'existe plus. Kayla, devant la page : « c'est pas d'actualité, on a quand
 * même corrigé pas mal ». C'était la dernière surface à porter cette promesse :
 * l'écran d'accueil du test et le brief l'avaient déjà perdue le même jour, et
 * la landing, elle, n'avait été relue par personne. Un candidat recruté sur la
 * mauvaise promesse s'en va au premier shift, pas au test.
 *
 * Ce que la page dit maintenant, et qui est vrai : l'IA fait le plus gros du
 * travail, l'humain reprend la main au moment décisif pour négocier et
 * conclure, et il touche une commission sur ce qu'il conclut.
 *
 * ⛔ CE QU'ELLE NE DIT TOUJOURS PAS, ET C'EST DÉLIBÉRÉ : le secteur. Cette page
 * est celle que les régies pub inspectent, et la nommer ferait refuser les
 * campagnes. Le candidat l'apprend à l'écran suivant — l'introduction du
 * formulaire le dit noir sur blanc, avant qu'il ne remplisse quoi que ce soit
 * (cf. `ProfileFormScreen`). Page IDENTIQUE pour Meta et pour le candidat :
 * aucun cloaking, la divulgation est juste à l'étape d'après.
 *
 * 🩸 ET ELLE NE PARLE PLUS DE TEST (13-09-2026). Elle disait « Commencer le
 * test → · Gratuit · 8 minutes », alors que le parcours public s'arrête au
 * formulaire depuis le 19-08 : le test se donne APRÈS, quand le candidat a
 * créé son compte (Discord, puis la porte du cockpit). Kayla : « je ne le
 * mettrai que quand ils créent leur compte ». Une page qui promet un test de
 * huit minutes et livre un formulaire de deux ment deux fois — sur ce qu'on
 * demande, et sur le temps que ça prend. La page dit donc ce qu'elle fait :
 * postuler. (Le `Lead` du pixel, lui, ne part plus d'ici depuis le 07-10 :
 * il part à l'envoi du formulaire.)
 *
 * 🩸 RÉÉCRITE ENCORE LE 13-09-2026, pour la même raison qu'en août : la promesse
 * avait re-dérivé. Elle disait « L'IA discute. Toi, tu conclus » et « fait le
 * plus gros du travail » — Kayla : « c'est plus vraiment vrai ». Ce qui est vrai
 * (cf. mémoire « Cyrano chauffe, l'humain vend », 08-09) : l'IA fait le
 * relationnel et la chauffe, mais c'est le CHATTEUR qui écrit, négocie et vend.
 * Trois autres décisions du même message : payé en USDT (l'équipe convertit
 * l'USDT en argent local, pas l'USDC), on veut des gens EXPÉRIMENTÉS (donc plus
 * de « aucune expérience requise »), et le créneau 03–09 ne se recrute plus (rouvert le 07-10)
 * (cf. `SHIFTS_RECRUTES` dans `constants.ts`).
 *
 * 🩸 07-10-2026 : la palette crème à l'orange chaud est partie. Kayla : « le
 * même thème que le cockpit […] noir et bleu, le plus minimaliste et le plus
 * simple possible ». La page porte `CANDIDATE_THEME` (le cockpit en sombre),
 * comme tout le parcours qui suit, et ne dit plus que l'essentiel : le poste,
 * la paie, les trois conditions (ordinateur, expérience, Discord), un bouton.
 */
export function RegieRecruitmentLanding() {
  const startMutation = usePostuler();
  const postuler = () => startMutation.mutate();

  return (
    <main
      style={CANDIDATE_THEME}
      data-theme="glass"
      className="dark flex min-h-dvh items-center justify-center bg-canvas px-4 py-12 text-fg"
    >
      <Carte remplissage="lg" className="flex w-full max-w-[520px] flex-col items-center px-6 py-10 text-center sm:px-10 sm:py-14">
        <h1 className="text-[40px] font-black leading-[1.05] tracking-[-0.04em] sm:text-[52px]">
          Tu chattes.<br />Tu vends.
        </h1>

        <p className="mt-5 text-balance text-[17px] leading-7 text-muted">
          Une IA chauffe les clients, c'est toi qui écris, négocies et conclus.{" "}
          <span className="font-semibold text-fg">10 % de commission par vente, en USDT.</span>
        </p>

        {/* Kayla, 06-10-2026 : l'obligation Discord ne se découvrait qu'à la
            porte du cockpit — des candidats s'arrêtaient là. Elle se dit
            AVANT, sur la page qui les fait entrer. */}
        <p className="mt-6 text-balance text-[14px] text-muted">
          Sur ordinateur · Expérience exigée · Compte Discord
        </p>

        <Button
          variant="accent"
          size="xl"
          className="mt-8 w-full sm:w-auto sm:px-14"
          disabled={startMutation.isPending}
          onClick={postuler}
        >
          {startMutation.isPending ? "Préparation…" : "Postuler"}
        </Button>

        <p className="mt-4 text-balance text-[13px] text-muted">
          Gratuit · 2 minutes · Ne verse jamais d'argent pour postuler
        </p>

        {startMutation.isError && (
          <Alerte
            ton="erreur"
            taille="sm"
            className="mt-4 text-left"
            texte="Impossible de démarrer la candidature. Réessaie dans quelques instants."
          />
        )}
      </Carte>
    </main>
  );
}
